import type { IContentPage, IImage } from '~~/lib/ContentfulService';

interface ContentPageTeaserSourceFields {
  teaserTitle?: string;
  teaserText?: string;
  teaserImage?: IImage;
  slug?: string;
  metadata?: {
    fields?: {
      teaserTitle?: string;
      teaserText?: string;
      teaserImage?: IImage;
      slug?: string;
    };
  };
}

export interface ContentPageTeaserCardFields {
  headline?: string;
  content?: string;
  teaserImage?: IImage;
  slug?: string;
}

/**
 * Reads teaser card fields from a contentPage linked in textTeaserCardList.
 * Prefers root-level fields (post DBP-1860) and falls back to metadata.
 */
export function extractContentPageTeaserCardFields(
  page: IContentPage
): ContentPageTeaserCardFields {
  const fields = page.fields as ContentPageTeaserSourceFields | undefined;
  const metadataFields = fields?.metadata?.fields;

  return {
    headline: fields?.teaserTitle ?? metadataFields?.teaserTitle,
    content: fields?.teaserText ?? metadataFields?.teaserText,
    teaserImage: fields?.teaserImage ?? metadataFields?.teaserImage,
    slug: fields?.slug ?? metadataFields?.slug
  };
}
